import { useCustom } from '@refinedev/core';
import { Card, Typography } from 'antd';
import { Pie } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { MonetizationByRenewalStatusOut } from '@/api/generated/schemas';
import { cleanFilters, type MonetizationStatsFilters } from './filters';

const STATUS_LABELS: Record<keyof MonetizationByRenewalStatusOut, string> = {
  will_renew: 'Odnowi się',
  will_not_renew: 'Nie odnowi się',
  unsubscribe_detected: 'Wykryto rezygnację',
  billing_issue: 'Problem z płatnością',
  in_grace_period: 'Okres karencji',
  will_change_product: 'Zmiana produktu',
  will_pause: 'Pauza',
};

const STATUS_COLORS: Record<keyof MonetizationByRenewalStatusOut, string> = {
  will_renew: '#52c41a',
  will_not_renew: '#8c8c8c',
  unsubscribe_detected: '#cf1322',
  billing_issue: '#faad14',
  in_grace_period: '#d46b08',
  will_change_product: '#1677ff',
  will_pause: '#722ed1',
};

const STATUS_KEYS = Object.keys(
  STATUS_LABELS
) as (keyof MonetizationByRenewalStatusOut)[];

type Props = { filters: MonetizationStatsFilters };

export const MonetizationRenewalStatusChart = ({ filters }: Props) => {
  const { query } = useCustom<MonetizationByRenewalStatusOut>({
    url: 'monetization/subscriptions/stats/by_renewal_status',
    method: 'get',
    config: { query: cleanFilters(filters) },
  });

  const stats = query.data?.data;
  const pieData = stats
    ? STATUS_KEYS.filter((key) => stats[key] > 0).map((key) => ({
        type: STATUS_LABELS[key],
        value: stats[key],
      }))
    : [];

  const colorRange = stats
    ? STATUS_KEYS.filter((key) => stats[key] > 0).map(
        (key) => STATUS_COLORS[key]
      )
    : [];

  return (
    <Card title="Status odnowienia" loading={query.isLoading}>
      {pieData.length > 0 ? (
        <Pie
          data={pieData}
          angleField="value"
          colorField="type"
          scale={{ color: { range: colorRange } }}
          innerRadius={0.6}
          height={260}
          legend={BOTTOM_LEGEND}
        />
      ) : (
        <Typography.Text type="secondary">Brak danych</Typography.Text>
      )}
    </Card>
  );
};
